module.exports = __webpack_public_path__ + "assets/img/logo-amex.bf615782.svg";